import { createTheme } from "@mui/material";
import { makeStyles } from '@mui/styles';

export const theme = createTheme(
    {
        typography: {
            allVariants: {
                fontFamily: `'Gantari', sans-serif`
            },
        },
        palette: {
            primary: { main: '#071D45' },
            error: { main: '#A70100' },
            btn:{main:'#0C6A96',contrastText:"#fff"}
        },
        shape: {
            borderRadius: 10,
        },
    }
);



export const useStyles = makeStyles({

    root: {
        "& .MuiDataGrid-renderingZone": {
            maxHeight: "none !important"
        },
        "& .MuiDataGrid-cell": {
            lineHeight: "unset !important",
            maxHeight: "none !important",
            whiteSpace: "normal"
        },
        "& .MuiDataGrid-row": {
            maxHeight: "none !important"
        },
        "&.MuiDataGrid-columnsContainer": {
            background: '#010310',
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#E7F7FF !important"
            // color: "red"
          },
        '& .super-app-theme--header': {
            backgroundColor: '#E7F7FF !important',
            color: '#000 !important',
        }, 
        
    }
});
